import { getNewsList, getArticleEntry } from "../../../data/models/article.model";
import { bus } from "@/main";

export default {
	name: "NewsPage",
	data() {
		return {
			lang: this.$route.params.lang,
			isReady: false,
			content: [],
			bgImage: null,
			totalPages: null,
			currentPage: 1,
			totalNews: null,
			articleSlug: null,
			article: null,
			url: window.location.href
		}
	},
	props: {},
	created() {
		this.getContent();
		window.addEventListener("mousemove", function () {
			let bg = document.getElementsByClassName('article__bg');
			if (bg && bg[0]){
				bg[0].style.left = event.pageX - bg[0].offsetWidth / 2 + 'px';
				bg[0].style.top = event.pageY - bg[0].offsetHeight / 2 + 'px';
			}
		});
	},
	watch: {
		"$route": function () {
			this.getContent();
			this.getArticle();
			this.url = window.location.href;
		}
	},
	computed: {},
	methods: {
		getContent() {
			let contentReady = new Promise((resolve, reject) => {
				getNewsList(1).then(
					content => {
						this.content = content.content;
						this.totalPages = content.totalPages;
						this.totalNews = content.totalNews;
						this.isReady = true;
						resolve(true)
					}
				);
			})
			this.getArticle();

			Promise.all([contentReady]).then(() => {
				bus.$emit("evalColors", true);
				bus.$emit("PAGE_IS_READY", true);
			})
		},
		getMoreContent(page) {
			getNewsList(1, page).then(content => {
				content.content.forEach(element => {
					this.content.push(element)
				});
				this.totalPages = content.totalPages;
				this.totalNews = content.totalNews;
				this.currentPage++;
			});
		},
		getArticle() {
			this.articleSlug = this.$route.params.article;
			if(this.articleSlug ) {
				getArticleEntry(this.articleSlug, "slug", 1).then(
					content => {
						this.article = content;
					}
				)
			}
		},
		showImage: function (event, value) {
			this.bgImage = value;
		},
		hideImage: function (value) {
			this.bgImage = null;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/news/news.page.js